// --------------------------------------------------------
// ModalDropdown - ModalDropdown
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useEffect, useState } from "react";
import CareLineDropdown from "../../../../../../components/dropdown/CareLineDropdown";
import { Text } from "../../../../../../components/UI/generalLayout/Layout.styled";
import Colors from "../../../../../../constants/Colors";
import useResponsiveInfo from "../../../../../../hooks/useResponsiveInfo";
import {
  ContainerModalDropdown,
  DivisorModal,
  IconDel,
} from "./ModalDropdown.styled";
import IconDelete from "../../../../../../assets/imgs/iconDelete.svg";
import { AllergieService } from "../../../../../../core/http/service/AllergieService";
import { addValueToObject } from "../../../../../../helpers/HelperFunctions";
import { removeFieldFromList } from "../../../../../../helpers/CareLineHelperFunctions";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ModalDropdown INTERFACE
// --------------------------------------------------------

interface IModalDropdown {
  tipos: any;
  List: any[];
  response: any;
  myAllergies: any;
  responseIndex: number;
  addAllergies: (value: any) => void;
  setGeneralErrors: (value: any) => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ModalDropdown = ({
  tipos,
  List = [],
  response,
  responseIndex,
  myAllergies,
  setGeneralErrors,
  addAllergies,
}: IModalDropdown) => {
  // --------------------------------------------------------
  // ModalDropdown PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();
  // --------------------------------------------------------
  const [selectedType, setSelectedType] = useState<any>();
  const [allergies, setAllergies] = useState<any>([]);

  // Função que remove alergias iguais na (Lista que o médico está criando)
  const getIdsList = (list: any[]) => {
    const ids: string[] = [];
    list.forEach((item) => {
      ids.push(item.alergeno.id);
    });

    return ids;
  };

  // Função que remove alergias iguais na (Lista que o paciente já possui)
  const getIdsListTwo = (list: any[]) => {
    const ids: string[] = [];
    list.forEach((item) => {
      ids.push(item.alergiaId);
    });

    return ids;
  };

  // Buscar os alérgenos na mudança do tipo, ou quando abre o modal.
  useEffect(() => {
    const service = new AllergieService();
    const selectedAll =
      selectedType?.nome !== "Todos" ? selectedType?.nome : "";

    service
      .getAllergiesFilter({
        tipo: selectedAll,
      })
      .then(({ data: { data } }) => {
        const list1 = data.filter((c: any) => {
          return !getIdsList(List).includes(c.id ?? "");
        });
        const list2 = list1.filter((c: any) => {
          return !getIdsListTwo(myAllergies).includes(c.id ?? "");
        });

        setAllergies(list2);
      })
      .catch((error): any => {
        setGeneralErrors([error]);
      });
  }, [selectedType]);

  // Mudar o tipo
  const toogleType = (value: any, index: number) => {
    setSelectedType(value);
  };

  // Selecionar a alergia
  const allergieSelected = (value: any) => {
    addValueToObject({ alergeno: value }, responseIndex, addAllergies);
  };

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <ContainerModalDropdown isMobile={isMobile}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          flexDirection: isMobile ? "column" : "row",
          backgroundColor: isMobile ? "#f8f9fa" : "",
        }}
      >
        <DivisorModal>
          <Text bold>
            Tipo da alergia <span style={{ color: "red" }}>*</span>
          </Text>
          <CareLineDropdown
            value={response.tipo}
            onChange={(value: any) => [toogleType(value, response.index)]}
            items={tipos}
            disabled={false}
            backgroundColor={Colors.SPM50}
            textColor={Colors.SPM600}
            placeholder="Selecione o tipo"
            containerStyle={{
              width: isMobile ? "100%" : "190px",
            }}
            allValue={[]}
          />
        </DivisorModal>

        <DivisorModal>
          <Text bold>Alérgeno</Text>

          <CareLineDropdown
            value={response.alergeno}
            onChange={(value: any) => {
              allergieSelected(value);
            }}
            items={allergies}
            disabled={selectedType ? false : true}
            backgroundColor={Colors.SPM50}
            textColor={Colors.SPM600}
            placeholder="Selecionar alérgeno"
            containerStyle={{
              width: isMobile ? "100%" : "400px",
            }}
            allValue={[]}
          />
        </DivisorModal>
        <div
          style={{
            width: "100%",
            marginTop: isMobile ? "10px" : "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: isMobile ? "center" : ""
          }}
        >
          {responseIndex !== 0 && (
            <IconDel
              isMobile={isMobile}
              src={IconDelete}
              alt="X"
              onClick={() =>
                addAllergies(removeFieldFromList(List, responseIndex))
              }
            />
          )}
        </div>
      </div>
    </ContainerModalDropdown>
  );
  // --------------------------------------------------------
};

export default ModalDropdown;
